<div class="border-bottom pb-4 pt-4 mb-2">
  <div class="d-flex align-items-center mb-2">
    <tr-icon [icon]="icon.webhooks" [size]="size.extraLarge" classes="mr-3"></tr-icon>
    <h2 class="m-0">Webhooks</h2>
  </div>

  <div class="table-responsive pl-5">
    <table *ngIf="!disabled" class="table table-striped tr-table">
      <thead>
        <th scope="col">URL</th>
        <th scope="col">Events</th>
        <th scope="col">Description</th>
        <th scope="col">Actions</th>
      </thead>
      <tbody>
        <ng-container *ngFor="let webhook of webhooks; index as i">
          <tr>
            <td [innerText]="webhook.url"></td>
            <td [innerText]="webhook.events.join(', ')"></td>
            <td [innerText]="webhook.description"></td>
            <td>
              <div class="d-flex">
                <button
                  class="btn btn-icon btn-info"
                  [disabled]="disabled"
                  (click)="editWebhook(webhook)"
                ><tr-icon [icon]="icon.edit" [white]="true"></tr-icon></button>
                <button
                  class="btn btn-icon btn-danger ml-2"
                  [disabled]="disabled"
                  (click)="deleteWebhook(webhook._id)"
                ><tr-icon [icon]="icon.delete" [white]="true"></tr-icon></button>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
    <div>
      <button
        id="addWebhook-button"
        type="button"
        class="btn btn-info"
        [disabled]="disabled"
        (click)="addWebhook()"
        style="width: 89px;"
      >Add</button>
    </div>
  </div>
</div>
